import { type IBackofficeFooterLayoutProps } from '@framework/theme/backoffice/BackofficeFooterLayout.tsx';
import { FooterContainer } from '../common/footer/FooterContainer.tsx';
import { FrontFooterLayout } from '../front/FrontFooterLayout.tsx';

/**
 * Footer admin.
 */
export function BackofficeFooterLayout(props: IBackofficeFooterLayoutProps) {
  return (
    <FooterContainer hasStaticFooter={props.hasStaticFooter}>
      <FrontFooterLayout />
    </FooterContainer>
  );
}
